import { backgroundOrange } from '@/theme/colors'
import { PendingAttachmentPicker } from '@components/Attachments'
import Modal from '@components/Modal'
import { EventCategory } from '@orbit/api-types'
import React, { useEffect, useState } from 'react'
import { emptyIdeaDraft, IdeaDraft, isIdeaDraftValid } from '../ideaForm'
import IdeaForm from './IdeaForm'
import { ButtonGroup, CancelButton, SubmitButton } from './IdeaForm.styles'
import { TestIds } from '@/testIds'

interface AddIdeaModalProps {
	isOpen: boolean
	onClose: () => void
	onSubmit: (draft: IdeaDraft, pendingFiles: File[]) => void
	categoryFilter?: EventCategory
}

const AddIdeaModal: React.FC<AddIdeaModalProps> = ({ isOpen, onClose, onSubmit, categoryFilter }) => {
	const [draft, setDraft] = useState<IdeaDraft>(() => emptyIdeaDraft(categoryFilter))
	const [pendingFiles, setPendingFiles] = useState<File[]>([])

	// Every opening starts fresh, on whichever category the grid is filtered to.
	useEffect(() => {
		if (isOpen) {
			setDraft(emptyIdeaDraft(categoryFilter))
			setPendingFiles([])
		}
	}, [isOpen, categoryFilter])

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (!isIdeaDraftValid(draft)) return
		onSubmit(draft, pendingFiles)
		onClose()
	}

	const formId = 'add-idea-form'

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Add Idea"
			closeOnBackdropClick={false}
			backgroundColor={backgroundOrange}
			footer={
				<ButtonGroup>
					<CancelButton type="button" onClick={onClose}>
						Cancel
					</CancelButton>
					<SubmitButton
						type="submit"
						form={formId}
						disabled={!isIdeaDraftValid(draft)}
						data-testid={TestIds.idea.submitButton}
					>
						Add Idea
					</SubmitButton>
				</ButtonGroup>
			}
		>
			<IdeaForm
				formId={formId}
				draft={draft}
				onDraftChange={setDraft}
				onSubmit={handleSubmit}
				attachmentSlot={
					<PendingAttachmentPicker files={pendingFiles} onChange={setPendingFiles} />
				}
			/>
		</Modal>
	)
}

export default AddIdeaModal
